/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DiscoveryDeviceFragment = {
	id: string;
	virtual: boolean;
	status: Types.DeviceStatus;
	hardwareId: string;
	isDevice: 'Device';
	advertisedInterface: { model: string | null };
	description: { model: string; interface: { version: { interfaceId: number } } };
	protocol: { dmp: { ipAddress: string } | null };
};

export type DiscoveryOnlineDeviceFragment = {
	features: { firmware: { version: string } | null };
} & DiscoveryDeviceFragment;

export type DiscoveryDevicesSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type DiscoveryDevicesSubscriptionOpResult = {
	discoveredDevices: { added: DiscoveryDeviceFragment } | { removed: string };
};

export type DiscoveryDeviceSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type DiscoveryDeviceSubscriptionOpResult = {
	nodeChanges:
		| DiscoveryOnlineDeviceFragment
		| { id: string; status: Types.DeviceStatus; isDeviceStatusChange: 'DeviceStatusChange' }
		| {};
};

export type DiscoverDevicesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type DiscoverDevicesQueryOpResult = {
	discoveredDevicesConnection: { edges: Array<{ node: DiscoveryOnlineDeviceFragment | null }> };
};

export const DiscoveryDeviceFragment = gql`
	fragment DiscoveryDeviceFragment on Device {
		isDevice: __typename
		id
		advertisedInterface {
			model
		}
		description {
			model
			interface {
				version {
					interfaceId
				}
			}
		}
		virtual
		status
		protocol {
			dmp {
				ipAddress
			}
		}
		hardwareId
	}
`;
export const DiscoveryOnlineDeviceFragment = gql`
	fragment DiscoveryOnlineDeviceFragment on Device {
		...DiscoveryDeviceFragment
		features {
			firmware {
				version
			}
		}
	}
	${DiscoveryDeviceFragment}
`;
export const DiscoveryDevicesSubscriptionDocument = gql`
	subscription DiscoveryDevicesSubscription {
		discoveredDevices {
			... on DeviceAdded {
				added {
					...DiscoveryDeviceFragment
				}
			}
			... on DeviceRemoved {
				removed
			}
		}
	}
	${DiscoveryDeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DiscoveryDevicesSubscriptionGQL extends Apollo.Subscription<
	DiscoveryDevicesSubscriptionOpResult,
	DiscoveryDevicesSubscriptionVariables
> {
	override document = DiscoveryDevicesSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DiscoveryDeviceSubscriptionDocument = gql`
	subscription DiscoveryDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on DeviceStatusChange {
				isDeviceStatusChange: __typename
				id
				status
			}
			...DiscoveryOnlineDeviceFragment
		}
	}
	${DiscoveryOnlineDeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DiscoveryDeviceSubscriptionGQL extends Apollo.Subscription<
	DiscoveryDeviceSubscriptionOpResult,
	DiscoveryDeviceSubscriptionVariables
> {
	override document = DiscoveryDeviceSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DiscoverDevicesQueryDocument = gql`
	query DiscoverDevicesQuery {
		discoveredDevicesConnection {
			edges {
				node {
					...DiscoveryOnlineDeviceFragment
				}
			}
		}
	}
	${DiscoveryOnlineDeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DiscoverDevicesQueryGQL extends Apollo.Query<DiscoverDevicesQueryOpResult, DiscoverDevicesQueryVariables> {
	override document = DiscoverDevicesQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
